
let baseUrl="https://service.cneexpo.com";
// let baseUrl="https://tzhfront-beta.easttone.com";
// let baseUrl="";
export default {

  //测试环境
  // //产品介绍表单Id
  productFormId:"1651147683191398401",
  // //活动表单Id
  // activityFormId:"1650684802213683202",



  // //正式环境
  // //产品介绍表单Id
  // productFormId:"1651147683191398401",
  // //活动表单Id
  // activityFormId:"1650687453987954689",

  // 获取logo的form
  logoFormId:"1475700290702929922",
  // 会议所属租户
  meetingTenantId:"834244",

  // 展商邀请函信息
  exhibitorInvitationInfo:  baseUrl+"/api/wdit-exhibitor/wdit-api/wditexhibitor-invitaion/exhibitor_invitation_info",
  //表单详情
  getFormDetail:baseUrl+"/api/wdit-exhibitor/wdit-api/wditexhibitor-invitaion/getInvitationFormDetail",

  getImg:baseUrl+"/api/wdit-exhibitor/wdit-api/wditexhibitor-invitaion/getInvitationImg",

  generatescheme:baseUrl+"/api/wdit-exhibitor/wdit-api/wditexhibitjump/generatescheme",

  getWechatConfig:baseUrl+"/api/wdit-exhibitor/wdit-api/wditexhibitjump/getWechatConfig",

  //座位查询
  searchMeetingSeat:baseUrl+"/api/meeting_seat/meetingSeat/search_by_name",
  //获取验证码
  captcha:baseUrl+"/api/meeting_seat/meetingSeat/oauth/captcha",
}



// WEBPACK FOOTER //
// ./src/util/data.js